import React from "react";
import { useSelector } from "react-redux";
import PieChart from "../../../../../components/pieChart/pieChart";

const Chart = () => {
  const {
    conversionInfo: { introsPurchased, notPurchased }
  } = useSelector((state) => state.firstVisitConversion);
  return (
    <PieChart
      data={[
        ["Intros Purchased", introsPurchased],
        [`Didn't Purchase`, notPurchased]
      ]}
      showLegend
    />
  );
};

export default Chart;
